
let version = window.$version ? window.$version : '1.1'
export class VueGlobal {
  constructor () {
    this.name = 'VueGlobal'
    this.global = ''
    this.user_info = null
    // this.loginURL = 'http://192.168.0.116/trainLogin/#/'
    // this.loginURL = 'http://192.168.12.248:8080/#/'
    this.loginURL = 'http://www.xmhgapi.com/train_login'
    // 学习时长
    this.learn_time = 0
    this.learnList = []
    this.station_id = 0 // 当前岗位id
    this.videoReadList = []
    this.basicsUnread = []
    this.version = version
    this.model = 1
    this.token = ''
    // 当前用户必学视频
    this.mustLearnVideo = 0
    this.gjl = null
    // 职位列表
    this.stationList = []
    // 部门列表
    this.branchList = []
    // 菜单列表
    this.menuList = []
    // 视频路径
    this.videoUrl = 'http://www.xmhgapi.com/train_video/'
    // 工具路径
    this.toolUrl = 'http://www.xmhgapi.com/train_tool/'
    // 文档路径
    this.bookUrl = 'http://www.xmhgapi.com/train_book/'
    // 第一次登录要看的文档路径
    this.loginBook = 'http://www.xmhgapi.com/train_loginBook/'
    // this.bookUrl = 'http://www.xmhgapi.com/'
    this.iconUrl = 'http://www.xmhgapi.com/train_userImg/'
    // this.iconUrl = 'http://www.xmhgapi.com/'
    this.examineList = [
      {
        id: 1,
        name: '三副考试'
      },
      {
        id: 2,
        name: '二副考试'
      },
      {
        id: 3,
        name: '大副考试'
      }
    ]
    this.learnType = [
      {
        id: 1,
        type: '基础业务'
      },
      {
        id: 2,
        type: '考核'
      },
      {
        id: 3,
        type: '法规'
      }
    ]
    this.exportList = []
    this.dialogVisible = false
  }
  getName (list, id, objName) {
    for (let i in list) {
      if (list[i].id === id) {
        return list[i][objName]
      }
    }
  }
  getUnreadByType (type) {
    let learnStr = this.user_info
    let learnObj = this.stringToJson(learnStr.study_record)
    let learnList = this.learnList
    let list = []
    for (let i in learnList) {
      let learn = learnList[i]
      let id = learn.id
      if (learn.type !== type) {
        continue
      }
      let job = learn.job
      if (job === 0 && learn.exclude != null) {
        let exclude = learn.exclude
        if (exclude.indexOf(learnStr.station_id) !== -1) { // 如果exclude 数组里边存在用户岗位 就直接跳过该书本 不添加
          continue
        }
      }
      let data = learnObj[id]
      if (data) {
        if (data.isOver) {
          continue
        }
      }
      list.push(learn)
    }
    this.basicsUnread = list
    return list
  }
  stringToJson (data) {
    if (typeof data === 'string') {
      try {
        const obj = JSON.parse(data)
        if (typeof obj === 'object' && obj) {
          return obj
        } else {
          return {}
        }
      } catch (e) {
        return {}
      }
    }
    return {}
  }
  compareMneuId (menuId) {
    if (menuId !== this.learn_menu && this.learn_menu > 0) {
      return false
    }
    return true
  }
  updateStudyRecord (newRecord) {
    this.user_info.study_record = newRecord
  }
  // 根据id获取书的阅读记录
  getIsRead (bookId) {
    let studyRecord = this.user_info.study_record
    let obj = this.stringToJson(studyRecord)
    if (!obj[bookId]) {
      return null
    }
    return obj[bookId]
  }
  // 分级获取菜单
  getLevel () {
    let list = this.menuList
    let arr = []
    for (let i in list) {
      let obj = list[i]
      let id = obj.id
      let fatherId = obj.father_id
      let res = this.getPermission(obj.main_id)
      if (!res) {
        continue
      }
      if (!fatherId) {
        arr.push(obj)
      }
      let array = this.children(id)
      if (array.length) {
        obj.children = array
      }
    }
    return arr
  }
  getCount (list) {
    let amount = list.length
    for (let i in list) {
      let obj = list[i]
      if (obj.children) {
        amount += obj.children.length
      }
    }
    return amount
  }
  children (id) {
    let list = this.menuList
    let arr = []
    for (let i in list) {
      let obj = list[i]
      let fatherId = obj.father_id
      if (fatherId === id) {
        arr.push(obj)
      }
    }
    return arr
  }
  // 判断用户有没有权限
  getPermission (mainId) {
    let list = this.user_info.mean_limit
    let res = list.indexOf(mainId)
    if (res > -1) {
      return true
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./src/global/index.js